// @flow
import update from 'immutability-helper';
import { ofType, StateObservable } from 'redux-observable';
import { catchError, mergeMap } from 'rxjs/operators';
import { endpoints, cancelOrderApi } from './api';
import { of } from 'rxjs';
import { push } from 'react-router-redux';
import { setNewAlert } from '../../../alert/duck';

import type { HTTPError } from '../../../../error';
import type { Order } from '../../../../entities';
import type { Observable } from 'rxjs';
import analytics from '../../../../analytics';
import type { RootState } from '../../../index';

type LookingForTravelersAction = {
  +type: string;
  +error?: HTTPError;
  +order?: Order;
  +orderId?: string;
};

export type LookingForTravelersState = {
  +isCanceling?: boolean;
  +cancelError?: HTTPError;
  +cancelSuccessful?: boolean;
};

// Actions
const LOOKING_FOR_TRAVELERS_CANCEL_ORDER_REQUEST = 'LOOKING_FOR_TRAVELERS_CANCEL_ORDER_REQUEST';
const LOOKING_FOR_TRAVELERS_CANCEL_ORDER_SUCCESS = 'LOOKING_FOR_TRAVELERS_CANCEL_ORDER_SUCCESS';
const LOOKING_FOR_TRAVELERS_CANCEL_ORDER_ERROR = 'LOOKING_FOR_TRAVELERS_CANCEL_ORDER_ERROR';

// Action Creators
export function cancelOrder(orderId: string): LookingForTravelersAction {
  return {
    type: LOOKING_FOR_TRAVELERS_CANCEL_ORDER_REQUEST,
    orderId,
  };
}

export function cancelOrderSuccess(order: Order): LookingForTravelersAction {
  return {
    type: LOOKING_FOR_TRAVELERS_CANCEL_ORDER_SUCCESS,
    order,
  }
}

export function cancelOrderErrorFn(error: HTTPError): LookingForTravelersAction {
  return {
    type: LOOKING_FOR_TRAVELERS_CANCEL_ORDER_ERROR,
    error,
  }
}


export const actions = {
  LOOKING_FOR_TRAVELERS_CANCEL_ORDER_REQUEST,
  LOOKING_FOR_TRAVELERS_CANCEL_ORDER_SUCCESS,
  LOOKING_FOR_TRAVELERS_CANCEL_ORDER_ERROR,
  cancelOrder,
  cancelOrderSuccess,
  cancelOrderErrorFn,
};

export const initialState: LookingForTravelersState = {};

// Reducer
export default function reducer(state: LookingForTravelersState = initialState,
                                action: LookingForTravelersAction): LookingForTravelersState {
  switch (action.type) {
    case LOOKING_FOR_TRAVELERS_CANCEL_ORDER_REQUEST:
      return update(state, {
        $unset: ['cancelError'],
        isCanceling: { $set: true },
      });
    case LOOKING_FOR_TRAVELERS_CANCEL_ORDER_SUCCESS:
      return update(state, {
        $unset: ['isCanceling', 'cancelError'],
        cancelSuccessful: { $set: true },
      });
    case LOOKING_FOR_TRAVELERS_CANCEL_ORDER_ERROR:
      return update(state, {
        $unset: ['isCanceling'],
        cancelError: { $set: action.error },
      });
    default:
      return state;
  }
}

// Epics
export function cancelOrderEpic(action$: Observable<LookingForTravelersAction>): Observable<LookingForTravelersAction> {
  return action$.pipe(
    ofType(LOOKING_FOR_TRAVELERS_CANCEL_ORDER_REQUEST),
    mergeMap(({ orderId }) => cancelOrderApi(undefined, {
        route: endpoints.CANCEL_ORDER.replace(':id', orderId)
      }).pipe(
      mergeMap((order: Order) => of(cancelOrderSuccess(order))),
      catchError((e: HTTPError) => {
        if (Math.round(e.code / 100) === 5) {
          return of(cancelOrderErrorFn(e),
            setNewAlert('order', 'error', undefined, 'httpErrors.post.500'),
          );
        } else if (e.code === 400) {
          console.log('e', e);
          if (e.data && e.data.name === 'InvalidStateError') {
            return of(cancelOrderErrorFn(e),
              setNewAlert('order', 'error', undefined, 'order.purchase.lookingForTravelers.cancelError'),
            );
          }
          return of(cancelOrderErrorFn(e),
            setNewAlert('order', 'error', undefined, 'httpErrors.post.400'),
          );
        }
        return of(cancelOrderErrorFn(e));
      }))
    ));
}



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/looking-for-traveler/duck.js